import publicpb from '../../../base/public.pb';
import registerPb from './register.pb';
import PbAjax from '../../pbajax';

let pbajax = new PbAjax();

class ThirdRegister {

    constructor(data = {}) {
        this.promise = this.register(data);
    }

    register(data) {
        let self = this;
        let defer = $.Deferred();
        const { Request, Response } = registerPb.ThirdCheck.Register;
        let ua = window.navigator.userAgent;

        let businessData = new Request(data);

        let requestData = {
            service: 'service',
            api: '/third/check/register',
            header: {
                'Accept-Language': 'zh-CN',
                'UserAgent': ua
            }
        }

        pbajax.do(
            requestData,
            businessData,
            function(res) {
                let dataWrap = publicpb.Result.decode(res);
                let data;
                
                if (dataWrap.code == 1) {
                    data = Response.decode(dataWrap.data.value);

                    let userInfo = Object.assign({}, data.profile, self.parseData(data.profile));

                    defer.resolve(userInfo);
                } else {
                    defer.reject(dataWrap);
                }
            },
            () => {
                defer.reject();
            },
            () => {
                defer.reject();
            });
        return defer.promise();
    }
    /*
     * 解析数据
     */
    parseData(data) {
        let balance = data.balance || {};

        return {
            uid: this.longToString(data.uid), // 用户UID
            balance: {
                diamond: this.longToInt(balance.diamond),
                bill: this.longToInt(balance.bill),
                inBill: this.longToInt(balance.inBill),
                outDiamond: this.longToInt(balance.outDiamond)
            },
            exp: this.longToInt(data.exp), // 用户经验值
            currentExp: this.longToInt(data.currentExp), //当前级的经验值
            nextExp: this.longToInt(data.nextExp), // 距离下一级还需要多少经验值
            chatroomid: this.longToString(data.chatroomid),
            officialAuth: data.officialAuth || 0 // 大V认证标识 1是 0否
        }
    }

    longToString(value) {
        return window.longToString(value);
    }

    longToInt(value) {
        value = this.longToString(value);

        return parseInt(value, 10) || 0;
    }
}

export default ThirdRegister;



// WEBPACK FOOTER //
// ./js/component/openjs/deps/login/thirdparty/register.js